import {
  useEffect,
} from 'react';
import 'swiper/css';
import { useSwiper } from 'swiper/react';

function Wheel({ wheelStatus }) {
  const swiper = useSwiper();
  useEffect(() => {
    if (wheelStatus === 'up') {
      swiper.slideNext();
    }
    if (wheelStatus === 'down') {
      swiper.slidePrev();
    }
  }, [wheelStatus])

  return null;
}

export default Wheel;
